import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Select from 'react-select';
import FileOption from './file_option';

import { retrieveRunRecords, updateRecordPage } from './store/actions/run_records';
import { setFile } from './store/actions/ui';

export class FileSelector extends React.Component {
  static propTypes = {
    files: PropTypes.object.isRequired,
    retrieveRunRecords: PropTypes.func.isRequired,
    selectedFileId: PropTypes.number,
    onSelectFile: PropTypes.func.isRequired,
    onUpdateRecordPage: PropTypes.func.isRequired,
  }

  handleSelectFile = (option) => {
    const { onSelectFile, retrieveRunRecords, onUpdateRecordPage } = this.props;
    const value = option.value;
    onSelectFile(value);
    onUpdateRecordPage(1);
    retrieveRunRecords();
  }

  render() {
    const { files, selectedFileId } = this.props;

    const mappedFiles = Object.values(files).filter((file) => {
      return !(file.mapperType === "Do Not Import" || file.mapperType === null);
    });


    const fileOptions = mappedFiles.map((file) => {
      return {
        id: file.id,
        value: file.id,
        label: file.name
      };
    });
    const fileIndex = mappedFiles.findIndex(file => file.id == selectedFileId);

    return (
      <div className="mb-4">
        <h5 className="larger-text">View File: </h5>
        <div className="d-inline-flex">
          <Select
            className="entity-selector"
            components = {{ Option: FileOption, SingleValue: FileOption }}
            isSearchable={false}
            options={fileOptions}
            value={fileOptions.find(file => file.value == selectedFileId)}
            onChange={this.handleSelectFile}
          />
          <span className="text-muted larger-text pl-4 pt-3">
            {fileIndex + 1} of {Object.keys(mappedFiles).length} files
          </span>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  files: state.importObject.files,
  selectedFileId: state.ui.selectedFileId
});

const mapDispatchToProps = {
  onSelectFile: setFile,
  onUpdateRecordPage: updateRecordPage,
  retrieveRunRecords
};

export default connect(mapStateToProps, mapDispatchToProps)(FileSelector);